module.exports = __webpack_public_path__ + "static/media/lohnt_es_sich.442dc477.png";